import React from 'react'
import { codeAppApiTypes } from '@/types'
import classes from './RouteLogsItem.module.scss'
import Typography from '@/components/ui/Typography'
import JSONPretty from 'react-json-pretty'
import clsx from 'clsx'

export type Props = {
  item: codeAppApiTypes.components['schemas']['CodeAppLog']
}

const RouteLogsItem = ({ item }: Props) => {
  const { type, line, char, data } = item

  const indicatorClassName = clsx(classes.indicator, {
    [classes.info]: type === 'INFO',
    [classes.response]: type === 'RESPONSE',
    [classes.error]: type === 'ERROR',
    [classes.systemError]: type === 'SYSTEM_ERROR',
  })

  return (
    <div className={classes.root}>
      <div className={classes.line}>
        <Typography variant={'caption'}>{type === 'RESPONSE' ? 'Response' : `Line: ${line}`}</Typography>
        <div className={indicatorClassName} />
      </div>
      <JSONPretty data={data} />
    </div>
  )
}

export default RouteLogsItem
